import { SaveGame as DLSaveGame, DeleteGame as DLDeleteGame, GetLotteryData as DLGetLotteryData, SaveLotteryData as DLSaveLotteryData } from './../DL/Games'


// const GetDinyamics = async () => {
//     try {
//         const response = await DLGetDinyamics()
        
//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: 'Lo sentimos. Hubo un error al intentar mostrar la información de la página. Inténtalo nuevamente o inténtalo más tarde.' }
//     }
// }

const SaveGame = async (gameData) => {
    try {
        const response = await DLSaveGame(gameData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteGame = async () => {
    try {
        const response = await DLDeleteGame()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//--- COLORS ---//

/**
 * Función que se encarga de eliminar las clases (estilos css) relacionados a 
 */
const RemoveExtraClassesOfColorsDynamic = async () => {
    try {
        // Borrar clases de temas de colores
        const classList = [
            "Colors--1--Primary",
            "Colors--1--Secondary",
            "Colors--2--Primary",
            "Colors--2--Secondary",
            "Colors--3--Primary",
            "Colors--4--Primary",
            "Colors--4--Secondary",
            "Colors--5--Primary",
            "Colors--5--Secondary",
            "Quiz__Background__Femenil--Blue",
            "Quiz__Background__Femenil--Golden"
        ]

        classList.forEach(item => {
            document.body.classList.remove(item)
            document.getElementById("fdmFooter")?.classList.remove(item)
        })
    } catch (error) {
        
    }
} 

//--- COLORS ---//

//--- LOTTERY ---//

const GetNewLotteryData = async (payload) => {
    try {
        if (payload?.view && payload?.board && payload?.BoardSize) {
            const board = []
                            
            payload.board.forEach(card => {
                board.push({
                    ...card,
                    isCorrect: false
                })
            })

            const lotteryData = {
                view: payload.view,
                board: board,
                boardSize: payload.BoardSize,
                lifes: {
                    total: payload.BoardSize * payload.BoardSize,
                    corrects: 0,
                    incorrects: 0
                }
            }

            return { success: true, data: lotteryData }
        } else {
            return { success: false, data: null }
        }
    } catch (error) {
        return { success: false, message: '' }
    }
}

const GetLotteryData = async (payload) => {
    try {
        const response = await DLGetLotteryData(payload)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SaveLotteryData = async (lotteryData) => {
    try {
        const response = await DLSaveLotteryData(lotteryData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//--- LOTTERY ---//

export { SaveGame, DeleteGame, RemoveExtraClassesOfColorsDynamic, GetNewLotteryData, GetLotteryData, SaveLotteryData };